/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/8/22
 */

import React from "react";
import {Stack, TextField} from "@mui/material";
import {addDays} from "date-fns";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

export interface DateRangePickerProps {
	range: Interval
	onChange: (range: Interval) => void
	startDateLabel?: string
	endDateLabel?: string
}

export default function DateTimeRangePicker({ range, onChange, startDateLabel, endDateLabel }: DateRangePickerProps) {

	const submit = (range: Interval) => {
		if (range.end < range.start) {
			onChange({ start: addDays(range.end, -7), end: range.end });
		} else {
			onChange(range);
		}
	}

	return (
		<Stack direction={"row"} spacing={2}>
			<DateTimePicker
				label={startDateLabel ?? "From"}
				value={range.start}
				onChange={(value: any) => {
					if (value) {
						submit({ start: value, end: range.end });
					}
				}}
				renderInput={(params: any) =>
					<TextField
						sx={{ width: "200px" }}
						variant={"standard"}
						{...params}
					/>
				}
			/>
			<DateTimePicker
				label={endDateLabel ?? "To"}
				value={range.end}
				onChange={(value: any) => {
					if (value) {
						submit({ start: range.start, end: value });
					}
				}}
				renderInput={(params: any) =>
					<TextField
						sx={{ width: "200px" }}
						variant={"standard"}
						{...params}
					/>
				}
			/>
		</Stack>
	);

}